{
  "version": 1,
  "asset_id": "180e61d7-b07a-47ae-a56a-f508ece45f79",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/180e61d7-b07a-47ae-a56a-f508ece45f79/lecanto-metal-roof-after-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/180e61d7-b07a-47ae-a56a-f508ece45f79/lecanto-metal-roof-after-480w.webp",
  "original_filename": "lecanto-metal-roof-after-480w.webp",
  "size": 44458,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
